module.exports = __webpack_public_path__ + "static/radiogx-d23e3c56bb0cc2c1fe05128bad19e432.png";